(function () {
	'use strict';
	angular.module('app.core')
		.directive('typeaheadFocus', typeaheadFocus);

	typeaheadFocus.$inject = ['$timeout'];
	function typeaheadFocus($timeout) {
		return {
			require: 'ngModel',
			link: linkFunction,
			scope: {
				typeaheadFocus: '='
			}
		};

		function linkFunction(scope, element, attr, ngModel) {
			//trigger the popup on 'click' because 'focus'
			//is also triggered after the item selection
			element.bind('focus', triggerPopupFocus);
			element.bind('click', triggerPopupClick);

			function triggerPopupFocus() {
				if (!scope.typeaheadFocus || !scope.typeaheadFocus.triggerOnFocus) return;
				scope.typeaheadFocus.triggerOnFocus = false;
				triggerPopup();
			}

			function triggerPopupClick() {
				if (scope.typeaheadFocus && !scope.typeaheadFocus.triggerOnClick) return;
				triggerPopup();
			}

			function triggerPopup() {
				var viewValue = ngModel.$viewValue;

				//restore to null value so that the typeahead can detect a change
				if (ngModel.$viewValue == ' ') {
					ngModel.$setViewValue(null);
				}

				//force trigger the popup
				ngModel.$setViewValue(' ');

				//set the actual value in case there was already a value in the input
				$timeout(function () {
					ngModel.$setViewValue(viewValue || ' ');
				}, 100);
			}
		}
	}
})();
